import React, { useRef, useState } from 'react'

interface ImageUploadButtonProps {
  onImageSelect: (file: File) => void
  disabled?: boolean
  isUploading?: boolean
}

export const ImageUploadButton: React.FC<ImageUploadButtonProps> = ({
  onImageSelect,
  disabled = false,
  isUploading = false
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null)
  const [dragOver, setDragOver] = useState(false)

  const handleClick = () => {
    if (disabled || isUploading) return
    fileInputRef.current?.click()
  }

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (file && isImageFile(file)) {
      onImageSelect(file)
    }
    // Reset input para permitir selecionar o mesmo arquivo novamente
    if (fileInputRef.current) {
      fileInputRef.current.value = ''
    }
  }

  const handleDragOver = (event: React.DragEvent) => {
    event.preventDefault()
    if (!disabled && !isUploading) {
      setDragOver(true)
    }
  }

  const handleDragLeave = (event: React.DragEvent) => {
    event.preventDefault()
    setDragOver(false)
  }

  const handleDrop = (event: React.DragEvent) => {
    event.preventDefault()
    setDragOver(false)
    
    if (disabled || isUploading) return

    const file = event.dataTransfer.files?.[0]
    if (file && isImageFile(file)) {
      onImageSelect(file)
    }
  }

  const isImageFile = (file: File): boolean => {
    return file.type.startsWith('image/')
  }

  return (
    <>
      <button
        type="button"
        className={`btn btn-sm btn-light-primary d-flex align-items-center ${
          disabled || isUploading ? 'disabled' : ''
        } ${dragOver ? 'btn-active-primary' : ''}`}
        onClick={handleClick}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        disabled={disabled || isUploading}
        title={isUploading ? 'Fazendo upload...' : 'Enviar imagem'}
        style={{ 
          whiteSpace: 'nowrap', 
          minHeight: '31px',
          minWidth: '45px',
          flexShrink: 0
        }}
      >
        {isUploading ? (
          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
        ) : (
          <>
            <i className="fas fa-image me-1"></i>
            <span className="d-none d-lg-inline">Imagem</span>
          </>
        )}
      </button>

      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />
    </>
  )
}